import MagstimTableTreatmentTemplateBase from './MagstimTableTreatmentTemplateBase';

import './MagstimTableCombinedTreatmentTemplate.css'

import { MagstimColor } from 'common'

class MagstimTableCombinedTreatmentTemplate extends MagstimTableTreatmentTemplateBase {
	initImpl = (configData, heightPx) => {
		if (undefined !== configData.select) {
			configData.select.unchecked.color = MagstimColor.MagstimTextBackground;
		}
		this.initGroupedTable(configData, heightPx);
	}
}

export default MagstimTableCombinedTreatmentTemplate;